import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGraphcoolComponent } from './simple-icons-graphcool.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGraphcoolComponent ],
    exports:      [ SimpleIconsGraphcoolComponent ],
    bootstrap:    []
})
export class SimpleIconsGraphcoolModule {}
